import { c as _c } from "react/compiler-runtime";
import { add } from 'date-fns';
import styled, { css } from 'styled-components';
import { Div } from '../helpers/StyledUtils';
import { Resolution } from '../../../utils/chart';
import { formatDate } from '../../../utils/date';
import { useDatePreferences } from '../../hooks/useDatePreferences';
const granularity_formating = {
  second: 'h:mm:ss a',
  minute: 'h:mm a',
  hour: 'MMM d, h:mm a',
  day: 'MMM d'
};
const StyledTimebarContainer = styled.div(() => css`
    display: grid;
    grid-auto-columns: minmax(0, 1fr);
    grid-auto-flow: column;
    width: 100%;
  `);
const StyledTimebarMarker = styled.div(({
  theme
}) => css`
    width: 1px;
    height: 6px;
    background-color: ${theme.colors.surface.container.neutral};
  `);
const StyledTimebarLabel = styled.div(({
  theme
}) => css`
    display: inline-block;
    width: max-content;
    font-size: ${theme.pxToRem(12)};
    font-weight: 500;
    color: ${theme.colors.on.neutral.secondary_neutral};
    margin-top: ${theme.spacing(1)};
    transform: translateX(-50%);
    text-align: center;
  `);
const HistogramTimebar: React.FC<{
  start_date: Date;
  resolution: Resolution;
}> = t0 => {
  const $ = _c(9);
  const {
    start_date,
    resolution
  } = t0;
  const {
    timezone
  } = useDatePreferences();
  let t1;
  if ($[0] !== resolution.steps) {
    t1 = Array.from(Array(resolution.steps).keys());
    $[0] = resolution.steps;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== resolution.factor_to_seconds || $[3] !== resolution.granularity || $[4] !== resolution.unit || $[5] !== start_date || $[6] !== t1 || $[7] !== timezone) {
    t2 = <Div flex={true}><StyledTimebarContainer>{t1.map(i => {
          const step_date = add(start_date, {
            seconds: i * resolution.unit * resolution.factor_to_seconds
          });
          const label = i !== 0 && i % 2 === 0 && formatDate(step_date, granularity_formating[resolution.granularity], timezone);
          return <div key={step_date.getTime()}>{label ? <><StyledTimebarMarker /><StyledTimebarLabel>{label}</StyledTimebarLabel></> : i !== 0 && <StyledTimebarMarker />}</div>;
        })}</StyledTimebarContainer></Div>;
    $[2] = resolution.factor_to_seconds;
    $[3] = resolution.granularity;
    $[4] = resolution.unit;
    $[5] = start_date;
    $[6] = t1;
    $[7] = timezone;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
};
export default HistogramTimebar;